<template>
  <div style="background: #FFFFFF">
    <div v-if="medicalAlleyStartsObjects !== null">
      <navigation class="navigation-holder" v-on:queryChanged="queryChanged"/>
      <div class="container-fluid d-flex p-0">
        <div class="side-container-holder card">
          <sidebar v-on:queryChanged="queryChanged" v-bind:medicalAlleyStartsObjects="medicalAlleyStartsObjects" style="overflow-y: scroll"/>
          <div class="" style="position: absolute; bottom: 0; width: 100%">
            <search-submission v-on:queryChanged="queryChanged"/>
          </div>
        </div>
        <div class="main-container-holder" style="">
          <div class="container-fluid mb-3">
            <div class="card introduction-card mb-3">
              <div class="card-body">
                <div class="introduction-title text-center">
                  Medical Alley Association Startup Data Tool
                </div>
                <hr/>
                <div class="introduction-detail mb-3">
                  Starting December 2021, the MAS system will reflect the vision for the Early Stage Ecosystem Tool. All capabilities found in the internal tool will remain, and there will be no public access to this system. The purpose of this change is to test UI/UX elements to deliver the best possible future product.
                  <br/>
                </div>
              </div>
            </div>
            <organization-list-container v-on:queryChanged="queryChanged" v-bind:medicalAlleyStartsObjects="medicalAlleyStartsObjects"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MedicalAlleyStartsV3API from '../../api/medicalAlleyStartsV3'
import Navigation from './Navigation'
import Sidebar from './Sidebar'
import OrganizationListContainer from './OrganizationListContainer'
import SearchSubmission from './SearchSubmission'
import { mapGetters } from 'vuex'

export default {
  name: '',
  data: function () {
    return {
      medicalAlleyStartsObjects: null
    }
  },
  components: {Navigation, Sidebar, SearchSubmission, OrganizationListContainer},
  computed: {
    ...mapGetters(['medicalAlleyStartsQuery'])
  },
  methods: {
    setMedicalAlleyStartsData () {
      this.$store.commit('setIsLoading', true)
      MedicalAlleyStartsV3API.getMedicalAlleyStartsV3Data(this.medicalAlleyStartsQuery).then(
        response => {
          this.medicalAlleyStartsObjects = response.data.data
          this.$store.commit('setIsLoading', false)
        }
      )
    },
    queryChanged () {
      this.setMedicalAlleyStartsData()
    }
  },
  created () {
    this.$store.commit('setNavigationBarVisibility', false)
    this.setMedicalAlleyStartsData()
  }
}
</script>

<style scoped>
  .introduction-card {

  }
  .navigation-holder{
    height: 8vh;
  }
  .main-container-holder {
    width: 80%;
    height: 92vh;
    overflow-y: scroll
  }
  .side-container-holder {
    width: 20%;
    height: 92vh;
  }
  .introduction-title {
    font-size: 2.1em;
    font-weight: 700;
    text-transform: uppercase;
  }
  .introduction-detail {
    font-weight: 300;
  }
  @media only screen and (min-width: 1500px) {
    .navigation-holder{
      height: 6vh;
    }
    .main-container-holder {
      height: 94vh;
    }
    .side-container-holder {
      height: 94vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/medicalAlleyStarts/Index.vue